// 这个必须在最前面
import { isProd } from "@/utils/envUtil";

export { default as http } from "http/http";
export { Header, ContentType } from "http/http";
export { default as qs } from "qs";
export { default as GetFormData } from "utils/GetFormData";
// 118 方案 P4 修复：enum/StatusCode.js 仅默认导出，原具名再导出
// export {StatusCode} 是从未生效的坏导出（rollup 在新增 aiApiUtil 引用边后
// 报错暴露），改为 default as 具名再导出，api-util 对外导出形态不变
export { default as StatusCode } from "enum/StatusCode";

export const Method = {
    GET: "get",
    POST: "post",
    PUT: "put",
    DELETE: "delete"
};

export const Global = {};
Global.online = isProd;

if (Global.online) {
    Global.BASE_URL = window.BASE_URL;
    Global.BASE_SOCKET = window.BASE_SOCKET;
} else {
    const domain = import.meta.env.VITE_CONFIG_SERVER_HOST;

    Global.BASE_URL = `http://${domain}:8090`;
    Global.BASE_SOCKET = `ws://${domain}:8090`;

    // Global.BASE_URL = "http://www.zhxjpt.cn"
    // Global.BASE_SOCKET = `ws://www.zhxjpt.cn`;

    // Global.BASE_URL = "http://www.qzrspt.cn";
    // Global.BASE_SOCKET = "ws://www.qzrspt.cn";

    // Global.BASE_URL = "https://www.5gscw.cn";
    // Global.BASE_SOCKET = "wss://www.5gscw.cn";
}

// 118 方案 D17：ai_mall_py 通道（直播观看域 REST/WS）动态推导、部署零注入——
// dev 与 prod 同逻辑：REST 相对路径 /ai-api（dev 走 vite 代理、prod 走 nginx
// 别名，均为「剥别名转发 8012/域名」同语义）；WS 用当前页面协议+host 拼
// ws(s)://host/ai-api（dev 为 vite dev server（ws 代理），prod 为站点域名
// 同源反代）。前端包与域名解耦，无需 global.js 注入。
export const AI_BASE_URL = "/ai-api";
export const AI_BASE_SOCKET = `${window.location.protocol === "https:" ? "wss:" : "ws:"}//${window.location.host}/ai-api`;
